module.exports = __webpack_public_path__ + "static/media/opening-times_1.63252649.svg";